"use strict";

exports.__esModule = true;
exports.chunkedProps = exports.allFormatters = exports.Options = exports.Exifr = void 0;
exports.createDictionary = x;
exports.default = void 0;
exports.extendDictionary = C;
exports.fileReaders = exports.fileParsers = exports.fetchUrlAsArrayBuffer = void 0;
exports.gps = fe;
exports.inheritables = exports.gpsOnlyOptions = void 0;
exports.orientation = ce;
exports.otherSegments = exports.orientationOnlyOptions = void 0;
exports.parse = Y;
exports.rotateCss = exports.rotateCanvas = exports.readBlobAsArrayBuffer = void 0;
exports.rotation = ye;
exports.tagValues = exports.tagRevivers = exports.tagKeys = exports.segmentsAndBlocks = exports.segments = exports.segmentParsers = exports.rotations = void 0;
exports.thumbnail = oe;
exports.thumbnailOnlyOptions = void 0;
exports.thumbnailUrl = ue;
exports.tiffExtractables = exports.tiffBlocks = void 0;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n4 = 0, F = function F() {}; return { s: F, n: function n() { return _n4 >= r.length ? { done: !0 } : { done: !1, value: r[_n4++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function e(e, t, s) {
  return t in e ? Object.defineProperty(e, t, {
    value: s,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = s, e;
}
var t = "undefined" != typeof self ? self : global;
var s = "undefined" != typeof navigator,
  i = s && "undefined" == typeof HTMLImageElement,
  n = !("undefined" == typeof global || "undefined" == typeof process || !process.versions || !process.versions.node),
  r = t.Buffer,
  a = !!r,
  h = function h(e) {
    return void 0 !== e;
  };
function f(e) {
  return void 0 === e || (e instanceof Map ? 0 === e.size : 0 === Object.values(e).filter(h).length);
}
function l(e) {
  var t = new Error(e);
  throw delete t.stack, t;
}
function o(e) {
  var t = function (e) {
    var t = 0;
    return e.ifd0.enabled && (t += 1024), e.exif.enabled && (t += 2048), e.makerNote && (t += 2048), e.userComment && (t += 1024), e.gps.enabled && (t += 512), e.interop.enabled && (t += 100), e.ifd1.enabled && (t += 1024), t + 2048;
  }(e);
  return e.jfif.enabled && (t += 50), e.xmp.enabled && (t += 2e4), e.iptc.enabled && (t += 14e3), e.icc.enabled && (t += 6e3), t;
}
var u = function u(e) {
    return String.fromCharCode.apply(null, e);
  },
  d = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
var c = /*#__PURE__*/function () {
  function c(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var s = arguments.length > 2 ? arguments[2] : undefined;
    var i = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, c);
    if ("boolean" == typeof i && (this.le = i), Array.isArray(e) && (e = new Uint8Array(e)), 0 === e) this.byteOffset = 0, this.byteLength = 0;else if (e instanceof ArrayBuffer) {
      void 0 === s && (s = e.byteLength - t);
      var _i = new DataView(e, t, s);
      this._swapDataView(_i);
    } else if (e instanceof Uint8Array || e instanceof DataView || e instanceof c) {
      void 0 === s && (s = e.byteLength - t), (t += e.byteOffset) + s > e.byteOffset + e.byteLength && l("Creating view outside of available memory in ArrayBuffer");
      var _i2 = new DataView(e.buffer, t, s);
      this._swapDataView(_i2);
    } else if ("number" == typeof e) {
      var _t = new DataView(new ArrayBuffer(e));
      this._swapDataView(_t);
    } else l("Invalid input argument for BufferView: " + e);
  }
  return _createClass(c, [{
    key: "_swapArrayBuffer",
    value: function _swapArrayBuffer(e) {
      this._swapDataView(new DataView(e));
    }
  }, {
    key: "_swapBuffer",
    value: function _swapBuffer(e) {
      this._swapDataView(new DataView(e.buffer, e.byteOffset, e.byteLength));
    }
  }, {
    key: "_swapDataView",
    value: function _swapDataView(e) {
      this.dataView = e, this.buffer = e.buffer, this.byteOffset = e.byteOffset, this.byteLength = e.byteLength;
    }
  }, {
    key: "_lengthToEnd",
    value: function _lengthToEnd(e) {
      return this.byteLength - e;
    }
  }, {
    key: "set",
    value: function set(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : c;
      return e instanceof DataView || e instanceof c ? e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : e instanceof ArrayBuffer && (e = new Uint8Array(e)), e instanceof Uint8Array || l("BufferView.set(): Invalid data argument."), this.toUint8().set(e, t), new s(this, t, e.byteLength);
    }
  }, {
    key: "subarray",
    value: function subarray(e, t) {
      return t = t || this._lengthToEnd(e), new c(this, e, t);
    }
  }, {
    key: "toUint8",
    value: function toUint8() {
      return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
    }
  }, {
    key: "getUint8Array",
    value: function getUint8Array(e, t) {
      return new Uint8Array(this.buffer, this.byteOffset + e, t);
    }
  }, {
    key: "getString",
    value: function getString() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.byteLength;
      var s = this.getUint8Array(e, t);
      return i = s, d ? d.decode(i) : a ? Buffer.from(i).toString("utf8") : decodeURIComponent(escape(u(i)));
      var i;
    }
  }, {
    key: "getLatin1String",
    value: function getLatin1String() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.byteLength;
      var s = this.getUint8Array(e, t);
      return u(s);
    }
  }, {
    key: "getUnicodeString",
    value: function getUnicodeString() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.byteLength;
      var s = [];
      for (var _i3 = 0; _i3 < t && e + _i3 < this.byteLength; _i3 += 2) s.push(this.getUint16(e + _i3));
      return u(s);
    }
  }, {
    key: "getInt8",
    value: function getInt8(e) {
      return this.dataView.getInt8(e);
    }
  }, {
    key: "getUint8",
    value: function getUint8(e) {
      return this.dataView.getUint8(e);
    }
  }, {
    key: "getInt16",
    value: function getInt16(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getInt16(e, t);
    }
  }, {
    key: "getInt32",
    value: function getInt32(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getInt32(e, t);
    }
  }, {
    key: "getUint16",
    value: function getUint16(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getUint16(e, t);
    }
  }, {
    key: "getUint32",
    value: function getUint32(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getUint32(e, t);
    }
  }, {
    key: "getFloat32",
    value: function getFloat32(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getFloat32(e, t);
    }
  }, {
    key: "getFloat64",
    value: function getFloat64(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getFloat64(e, t);
    }
  }, {
    key: "getFloat",
    value: function getFloat(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getFloat32(e, t);
    }
  }, {
    key: "getDouble",
    value: function getDouble(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getFloat64(e, t);
    }
  }, {
    key: "getUintBytes",
    value: function getUintBytes(e, t, s) {
      switch (t) {
        case 1:
          return this.getUint8(e, s);
        case 2:
          return this.getUint16(e, s);
        case 4:
          return this.getUint32(e, s);
        case 8:
          return this.getUint64 && this.getUint64(e, s);
      }
    }
  }, {
    key: "getUint",
    value: function getUint(e, t, s) {
      switch (t) {
        case 8:
          return this.getUint8(e, s);
        case 16:
          return this.getUint16(e, s);
        case 32:
          return this.getUint32(e, s);
        case 64:
          return this.getUint64 && this.getUint64(e, s);
      }
    }
  }, {
    key: "toString",
    value: function toString(e) {
      return this.dataView.toString(e, this.constructor.name);
    }
  }, {
    key: "ensureChunk",
    value: function ensureChunk() {}
  }], [{
    key: "from",
    value: function from(e, t) {
      return e instanceof this && e.le === t ? e : new c(e, void 0, void 0, t);
    }
  }]);
}();
function p(e, t) {
  l("".concat(e, " '").concat(t, "' was not loaded, try using full build of exifr."));
}
var g = /*#__PURE__*/function (_Map) {
  function g(e) {
    var _this;
    _classCallCheck(this, g);
    _this = _callSuper(this, g), _this.kind = e;
    return _this;
  }
  _inherits(g, _Map);
  return _createClass(g, [{
    key: "get",
    value: function get(e, t) {
      return this.has(e) || p(this.kind, e), t && (e in t || function (e, t) {
        l("Unknown ".concat(e, " '").concat(t, "'."));
      }(this.kind, e), t[e].enabled || p(this.kind, e)), _superPropGet(g, "get", this, 3)([e]);
    }
  }, {
    key: "keyList",
    value: function keyList() {
      return Array.from(this.keys());
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Map));
var m = exports.fileParsers = new g("file parser"),
  y = exports.segmentParsers = new g("segment parser"),
  b = exports.fileReaders = new g("file reader");
var w = t.fetch;
function k(e, t) {
  return (i = e).startsWith("data:") || i.length > 1e4 ? v(e, t, "base64") : n && e.includes("://") ? O(e, t, "url", S) : n ? v(e, t, "fs") : s ? O(e, t, "url", S) : void l("Invalid input argument");
  var i;
}
function O(_x, _x2, _x3, _x4) {
  return _O.apply(this, arguments);
}
function _O() {
  _O = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(e, t, s, i) {
    return _regenerator().w(function (_context24) {
      while (1) switch (_context24.n) {
        case 0:
          return _context24.a(2, b.has(s) ? v(e, t, s) : i ? function () {
            var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(e, t) {
              var s;
              return _regenerator().w(function (_context23) {
                while (1) switch (_context23.n) {
                  case 0:
                    _context23.n = 1;
                    return t(e);
                  case 1:
                    s = _context23.v;
                    return _context23.a(2, new c(s));
                }
              }, _callee23);
            }));
            return function (_x24, _x25) {
              return _ref20.apply(this, arguments);
            };
          }()(e, i) : void l("Parser ".concat(s, " is not loaded")));
      }
    }, _callee24);
  }));
  return _O.apply(this, arguments);
}
function v(_x5, _x6, _x7) {
  return _v.apply(this, arguments);
}
function _v() {
  _v = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(e, t, s) {
    var i;
    return _regenerator().w(function (_context25) {
      while (1) switch (_context25.n) {
        case 0:
          i = new (b.get(s))(e, t);
          _context25.n = 1;
          return i.read();
        case 1:
          return _context25.a(2, i);
      }
    }, _callee25);
  }));
  return _v.apply(this, arguments);
}
var S = exports.fetchUrlAsArrayBuffer = function S(e) {
    return w(e).then(function (e) {
      return e.arrayBuffer();
    });
  },
  A = exports.readBlobAsArrayBuffer = function A(e) {
    return new Promise(function (t, s) {
      var i = new FileReader();
      i.onloadend = function () {
        return t(i.result || new ArrayBuffer());
      }, i.onerror = s, i.readAsArrayBuffer(e);
    });
  };
var U = /*#__PURE__*/function (_Map2) {
  function U() {
    _classCallCheck(this, U);
    return _callSuper(this, U, arguments);
  }
  _inherits(U, _Map2);
  return _createClass(U, [{
    key: "tagKeys",
    get: function get() {
      return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
    }
  }, {
    key: "tagValues",
    get: function get() {
      return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Map));
function x(e, t, s) {
  var i = new U();
  var _iterator = _createForOfIteratorHelper(s),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref = _step.value;
      var _ref2 = _slicedToArray(_ref, 2);
      var _e = _ref2[0];
      var _t2 = _ref2[1];
      i.set(_e, _t2);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (Array.isArray(t)) {
    var _iterator2 = _createForOfIteratorHelper(t),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _s = _step2.value;
        e.set(_s, i);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } else e.set(t, i);
  return i;
}
function C(e, t, s) {
  var i,
    n = e.get(t);
  var _iterator3 = _createForOfIteratorHelper(s),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      i = _step3.value;
      n.set(i[0], i[1]);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
var B = exports.tagKeys = new Map(),
  V = exports.tagValues = new Map(),
  I = exports.tagRevivers = new Map(),
  L = exports.chunkedProps = ["chunked", "firstChunkSize", "firstChunkSizeNode", "firstChunkSizeBrowser", "chunkSize", "chunkLimit"],
  T = exports.otherSegments = ["jfif", "xmp", "icc", "iptc", "ihdr"],
  z = exports.segments = ["tiff"].concat(T),
  P = exports.tiffBlocks = ["ifd0", "ifd1", "exif", "gps", "interop"],
  F = exports.segmentsAndBlocks = [].concat(_toConsumableArray(z), P),
  j = exports.tiffExtractables = ["makerNote", "userComment"],
  E = exports.inheritables = ["translateKeys", "translateValues", "reviveValues", "multiSegment"],
  M = exports.allFormatters = [].concat(E, ["sanitize", "mergeOutput", "silentErrors"]);
var _ = /*#__PURE__*/function () {
  function _() {
    _classCallCheck(this, _);
  }
  return _createClass(_, [{
    key: "translate",
    get: function get() {
      return this.translateKeys || this.translateValues || this.reviveValues;
    }
  }]);
}();
var D = /*#__PURE__*/function (_ref3) {
  function D(t, s, i, n) {
    var _this2;
    _classCallCheck(this, D);
    if (_this2 = _callSuper(this, D), e(_assertThisInitialized(_this2), "enabled", !1), e(_assertThisInitialized(_this2), "skip", new Set()), e(_assertThisInitialized(_this2), "pick", new Set()), e(_assertThisInitialized(_this2), "deps", new Set()), e(_assertThisInitialized(_this2), "translateKeys", !1), e(_assertThisInitialized(_this2), "translateValues", !1), e(_assertThisInitialized(_this2), "reviveValues", !1), _this2.key = t, _this2.enabled = s, _this2.parse = _this2.enabled, _this2.applyInheritables(n), _this2.canBeFiltered = P.includes(t), _this2.canBeFiltered && (_this2.dict = B.get(t)), void 0 !== i) if (Array.isArray(i)) _this2.parse = _this2.enabled = !0, _this2.canBeFiltered && i.length > 0 && _this2.translateTagSet(i, _this2.pick);else if ("object" == _typeof(i)) {
      if (_this2.enabled = !0, _this2.parse = !1 !== i.parse, _this2.canBeFiltered) {
        var _e2 = i.pick,
          _t3 = i.skip;
        _e2 && _e2.length > 0 && _this2.translateTagSet(_e2, _this2.pick), _t3 && _t3.length > 0 && _this2.translateTagSet(_t3, _this2.skip);
      }
      _this2.applyInheritables(i);
    } else !0 === i || !1 === i ? _this2.parse = _this2.enabled = i : l("Invalid options argument: ".concat(i));
    return _this2;
  }
  _inherits(D, _ref3);
  return _createClass(D, [{
    key: "needed",
    get: function get() {
      return this.enabled || this.deps.size > 0;
    }
  }, {
    key: "applyInheritables",
    value: function applyInheritables(e) {
      var t, s;
      for (var _i4 = 0, _E = E; _i4 < _E.length; _i4++) {
        t = _E[_i4];
        s = e[t], void 0 !== s && (this[t] = s);
      }
    }
  }, {
    key: "translateTagSet",
    value: function translateTagSet(e, t) {
      if (this.dict) {
        var _s2,
          _i5,
          _this$dict = this.dict,
          _n = _this$dict.tagKeys,
          _r = _this$dict.tagValues;
        var _iterator4 = _createForOfIteratorHelper(e),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            _s2 = _step4.value;
            "string" == typeof _s2 ? (_i5 = _r.indexOf(_s2), -1 === _i5 && (_i5 = _n.indexOf(Number(_s2))), -1 !== _i5 && t.add(Number(_n[_i5]))) : t.add(_s2);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } else {
        var _iterator5 = _createForOfIteratorHelper(e),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _s3 = _step5.value;
            t.add(_s3);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }, {
    key: "finalizeFilters",
    value: function finalizeFilters() {
      !this.enabled && this.deps.size > 0 ? (this.enabled = !0, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
    }
  }]);
}(_);
var N = {
    jfif: !1,
    tiff: !0,
    xmp: !1,
    icc: !1,
    iptc: !1,
    ifd0: !0,
    ifd1: !1,
    exif: !0,
    gps: !0,
    interop: !1,
    ihdr: void 0,
    makerNote: !1,
    userComment: !1,
    multiSegment: !1,
    skip: [],
    pick: [],
    translateKeys: !0,
    translateValues: !0,
    reviveValues: !0,
    sanitize: !0,
    mergeOutput: !0,
    silentErrors: !0,
    chunked: !0,
    firstChunkSize: void 0,
    firstChunkSizeNode: 512,
    firstChunkSizeBrowser: 65536,
    chunkSize: 65536,
    chunkLimit: 5
  },
  $ = new Map();
var R = exports.Options = /*#__PURE__*/function (_ref4) {
  function R(e) {
    var _this3;
    _classCallCheck(this, R);
    _this3 = _callSuper(this, R), !0 === e ? _this3.setupFromTrue() : void 0 === e ? _this3.setupFromUndefined() : Array.isArray(e) ? _this3.setupFromArray(e) : "object" == _typeof(e) ? _this3.setupFromObject(e) : l("Invalid options argument ".concat(e)), void 0 === _this3.firstChunkSize && (_this3.firstChunkSize = s ? _this3.firstChunkSizeBrowser : _this3.firstChunkSizeNode), _this3.mergeOutput && (_this3.ifd1.enabled = !1), _this3.filterNestedSegmentTags(), _this3.traverseTiffDependencyTree(), _this3.checkLoadedPlugins();
    return _this3;
  }
  _inherits(R, _ref4);
  return _createClass(R, [{
    key: "setupFromUndefined",
    value: function setupFromUndefined() {
      var e;
      for (var _i6 = 0, _L = L; _i6 < _L.length; _i6++) {
        e = _L[_i6];
        this[e] = N[e];
      }
      var _iterator6 = _createForOfIteratorHelper(M),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          e = _step6.value;
          this[e] = N[e];
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      for (var _i7 = 0, _j = j; _i7 < _j.length; _i7++) {
        e = _j[_i7];
        this[e] = N[e];
      }
      var _iterator7 = _createForOfIteratorHelper(F),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          e = _step7.value;
          this[e] = new D(e, N[e], void 0, this);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "setupFromTrue",
    value: function setupFromTrue() {
      var e;
      for (var _i8 = 0, _L2 = L; _i8 < _L2.length; _i8++) {
        e = _L2[_i8];
        this[e] = N[e];
      }
      var _iterator8 = _createForOfIteratorHelper(M),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          e = _step8.value;
          this[e] = N[e];
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      for (var _i9 = 0, _j2 = j; _i9 < _j2.length; _i9++) {
        e = _j2[_i9];
        this[e] = !0;
      }
      var _iterator9 = _createForOfIteratorHelper(F),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          e = _step9.value;
          this[e] = new D(e, !0, void 0, this);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "setupFromArray",
    value: function setupFromArray(e) {
      var t;
      for (var _i0 = 0, _L3 = L; _i0 < _L3.length; _i0++) {
        t = _L3[_i0];
        this[t] = N[t];
      }
      var _iterator0 = _createForOfIteratorHelper(M),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          t = _step0.value;
          this[t] = N[t];
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      for (var _i1 = 0, _j3 = j; _i1 < _j3.length; _i1++) {
        t = _j3[_i1];
        this[t] = N[t];
      }
      var _iterator1 = _createForOfIteratorHelper(F),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          t = _step1.value;
          this[t] = new D(t, !1, void 0, this);
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      this.setupGlobalFilters(e, void 0, P);
    }
  }, {
    key: "setupFromObject",
    value: function setupFromObject(e) {
      var t;
      for (var _i10 = 0, _arr = (P.ifd0 = P.ifd0 || P.image, P.ifd1 = P.ifd1 || P.thumbnail, Object.assign(this, e), L); _i10 < _arr.length; _i10++) {
        t = _arr[_i10];
        this[t] = W(e[t], N[t]);
      }
      var _iterator10 = _createForOfIteratorHelper(M),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          t = _step10.value;
          this[t] = W(e[t], N[t]);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      for (var _i11 = 0, _j4 = j; _i11 < _j4.length; _i11++) {
        t = _j4[_i11];
        this[t] = W(e[t], N[t]);
      }
      var _iterator11 = _createForOfIteratorHelper(z),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          t = _step11.value;
          this[t] = new D(t, N[t], e[t], this);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      for (var _i12 = 0, _P = P; _i12 < _P.length; _i12++) {
        t = _P[_i12];
        this[t] = new D(t, N[t], e[t], this.tiff);
      }
      this.setupGlobalFilters(e.pick, e.skip, P, F), !0 === e.tiff ? this.batchEnableWithBool(P, !0) : !1 === e.tiff ? this.batchEnableWithUserValue(P, e) : Array.isArray(e.tiff) ? this.setupGlobalFilters(e.tiff, void 0, P) : "object" == _typeof(e.tiff) && this.setupGlobalFilters(e.tiff.pick, e.tiff.skip, P);
    }
  }, {
    key: "batchEnableWithBool",
    value: function batchEnableWithBool(e, t) {
      var _iterator12 = _createForOfIteratorHelper(e),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _s4 = _step12.value;
          this[_s4].enabled = t;
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }, {
    key: "batchEnableWithUserValue",
    value: function batchEnableWithUserValue(e, t) {
      var _iterator13 = _createForOfIteratorHelper(e),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _s5 = _step13.value;
          var _e3 = t[_s5];
          this[_s5].enabled = !1 !== _e3 && void 0 !== _e3;
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
  }, {
    key: "setupGlobalFilters",
    value: function setupGlobalFilters(e, t, s) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : s;
      if (e && e.length) {
        var _iterator14 = _createForOfIteratorHelper(i),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var _e4 = _step14.value;
            this[_e4].enabled = !1;
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
        var _t4 = K(e, s);
        var _iterator15 = _createForOfIteratorHelper(_t4),
          _step15;
        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var _ref5 = _step15.value;
            var _ref6 = _slicedToArray(_ref5, 2);
            var _e5 = _ref6[0];
            var _s6 = _ref6[1];
            X(this[_e5].pick, _s6), this[_e5].enabled = !0;
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }
      } else if (t && t.length) {
        var _e6 = K(t, s);
        var _iterator16 = _createForOfIteratorHelper(_e6),
          _step16;
        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var _ref7 = _step16.value;
            var _ref8 = _slicedToArray(_ref7, 2);
            var _t5 = _ref8[0];
            var _s7 = _ref8[1];
            X(this[_t5].skip, _s7);
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
      }
    }
  }, {
    key: "filterNestedSegmentTags",
    value: function filterNestedSegmentTags() {
      var e = this.ifd0,
        t = this.exif,
        s = this.xmp,
        i = this.iptc,
        n = this.icc;
      this.makerNote ? t.deps.add(37500) : t.skip.add(37500), this.userComment ? t.deps.add(37510) : t.skip.add(37510), s.enabled || e.skip.add(700), i.enabled || e.skip.add(33723), n.enabled || e.skip.add(34675);
    }
  }, {
    key: "traverseTiffDependencyTree",
    value: function traverseTiffDependencyTree() {
      var _this4 = this;
      var e = this.ifd0,
        t = this.exif,
        s = this.gps,
        i = this.interop;
      i.needed && (t.deps.add(40965), e.deps.add(40965)), t.needed && e.deps.add(34665), s.needed && e.deps.add(34853), this.tiff.enabled = P.some(function (e) {
        return !0 === _this4[e].enabled;
      }) || this.makerNote || this.userComment;
      for (var _i13 = 0, _P2 = P; _i13 < _P2.length; _i13++) {
        var _e7 = _P2[_i13];
        this[_e7].finalizeFilters();
      }
    }
  }, {
    key: "onlyTiff",
    get: function get() {
      var _this5 = this;
      return !T.map(function (e) {
        return _this5[e].enabled;
      }).some(function (e) {
        return !0 === e;
      }) && this.tiff.enabled;
    }
  }, {
    key: "checkLoadedPlugins",
    value: function checkLoadedPlugins() {
      var _iterator17 = _createForOfIteratorHelper(z),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _e8 = _step17.value;
          this[_e8].enabled && !y.has(_e8) && p("segment parser", _e8);
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  }], [{
    key: "useCached",
    value: function useCached(e) {
      var t = $.get(e);
      return void 0 !== t || (t = new this(e), $.set(e, t)), t;
    }
  }]);
}(_);
function K(e, t) {
  var s,
    i,
    n,
    r,
    a = [];
  var _iterator18 = _createForOfIteratorHelper(t),
    _step18;
  try {
    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
      n = _step18.value;
      var _iterator19 = _createForOfIteratorHelper((s = B.get(n), i = [], s)),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          r = _step19.value;
          (e.includes(r[0]) || e.includes(r[1])) && i.push(r[0]);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      i.length && a.push([n, i]);
    }
  } catch (err) {
    _iterator18.e(err);
  } finally {
    _iterator18.f();
  }
  return a;
}
function W(e, t) {
  return void 0 !== e ? e : void 0 !== t ? t : void 0;
}
function X(e, t) {
  var _iterator20 = _createForOfIteratorHelper(t),
    _step20;
  try {
    for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
      var _s8 = _step20.value;
      e.add(_s8);
    }
  } catch (err) {
    _iterator20.e(err);
  } finally {
    _iterator20.f();
  }
}
e(R, "default", N);
var H = exports.Exifr = /*#__PURE__*/function () {
  function H(t) {
    var _this6 = this;
    _classCallCheck(this, H);
    e(this, "parsers", {}), e(this, "output", {}), e(this, "errors", []), e(this, "pushToErrors", function (e) {
      return _this6.errors.push(e);
    }), this.options = R.useCached(t);
  }
  return _createClass(H, [{
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return function (e, t) {
                return "string" == typeof e ? k(e, t) : s && !i && e instanceof HTMLImageElement ? k(e.src, t) : e instanceof Uint8Array || e instanceof ArrayBuffer || e instanceof DataView ? new c(e) : s && e instanceof Blob ? O(e, t, "blob", A) : void l("Invalid input argument");
              }(e, this.options);
            case 1:
              this.file = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function read(_x8) {
        return _read.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "setup",
    value: function setup() {
      if (this.fileParser) return;
      var e = this.file,
        t = e.getUint16(0);
      var _iterator21 = _createForOfIteratorHelper(m),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _ref9 = _step21.value;
          var _ref0 = _slicedToArray(_ref9, 2);
          var _s9 = _ref0[0];
          var _i14 = _ref0[1];
          if (_i14.canHandle(e, t)) return this.fileParser = new _i14(this.options, this.file, this.parsers), e[_s9] = !0;
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      this.file.close && this.file.close(), l("Unknown file format");
    }
  }, {
    key: "parse",
    value: function () {
      var _parse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var e, t, s;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              e = this.output, t = this.errors;
              this.setup();
              if (!this.options.silentErrors) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.executeParsers().catch(this.pushToErrors);
            case 1:
              t.push.apply(t, _toConsumableArray(this.fileParser.errors));
              _context2.n = 3;
              break;
            case 2:
              _context2.n = 3;
              return this.executeParsers();
            case 3:
              this.file.close && this.file.close();
              this.options.silentErrors && t.length > 0 && (e.errors = t);
              return _context2.a(2, f(s = e) ? void 0 : s);
          }
        }, _callee2, this);
      }));
      function parse() {
        return _parse.apply(this, arguments);
      }
      return parse;
    }()
  }, {
    key: "executeParsers",
    value: function () {
      var _executeParsers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this7 = this;
        var e, t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              e = this.output;
              _context4.n = 1;
              return this.fileParser.parse();
            case 1:
              t = Object.values(this.parsers).map(/*#__PURE__*/function () {
                var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(t) {
                  var s;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        _context3.n = 1;
                        return t.parse();
                      case 1:
                        s = _context3.v;
                        t.assignToOutput(e, s);
                      case 2:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x9) {
                  return _ref1.apply(this, arguments);
                };
              }());
              this.options.silentErrors && (t = t.map(function (e) {
                return e.catch(_this7.pushToErrors);
              }));
              _context4.n = 2;
              return Promise.all(t);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function executeParsers() {
        return _executeParsers.apply(this, arguments);
      }
      return executeParsers;
    }()
  }, {
    key: "extractThumbnail",
    value: function () {
      var _extractThumbnail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var e, t, s, i, n, r, a, _t6;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.setup();
              e = this.options, t = this.file, s = y.get("tiff", e);
              if (!t.tiff) {
                _context5.n = 1;
                break;
              }
              i = {
                start: 0,
                type: "tiff"
              };
              _context5.n = 3;
              break;
            case 1:
              _t6 = t.jpeg;
              if (!_t6) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return this.fileParser.getOrFindSegment("tiff");
            case 2:
              i = _context5.v;
            case 3:
              if (!(void 0 === i)) {
                _context5.n = 4;
                break;
              }
              return _context5.a(2);
            case 4:
              _context5.n = 5;
              return this.fileParser.ensureSegmentChunk(i);
            case 5:
              n = _context5.v;
              r = this.parsers.tiff = new s(n, e, t);
              _context5.n = 6;
              return r.extractThumbnail();
            case 6:
              a = _context5.v;
              return _context5.a(2, (t.close && t.close(), a));
          }
        }, _callee5, this);
      }));
      function extractThumbnail() {
        return _extractThumbnail.apply(this, arguments);
      }
      return extractThumbnail;
    }()
  }]);
}();
function Y(_x0, _x1) {
  return _Y.apply(this, arguments);
}
function _Y() {
  _Y = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(e, t) {
    var s;
    return _regenerator().w(function (_context26) {
      while (1) switch (_context26.n) {
        case 0:
          s = new H(t);
          _context26.n = 1;
          return s.read(e);
        case 1:
          return _context26.a(2, s.parse());
      }
    }, _callee26);
  }));
  return _Y.apply(this, arguments);
}
var G = Object.freeze({
  __proto__: null,
  parse: Y,
  Exifr: H,
  fileParsers: m,
  segmentParsers: y,
  fileReaders: b,
  tagKeys: B,
  tagValues: V,
  tagRevivers: I,
  createDictionary: x,
  extendDictionary: C,
  fetchUrlAsArrayBuffer: S,
  readBlobAsArrayBuffer: A,
  chunkedProps: L,
  otherSegments: T,
  segments: z,
  tiffBlocks: P,
  segmentsAndBlocks: F,
  tiffExtractables: j,
  inheritables: E,
  allFormatters: M,
  Options: R
});
var J = /*#__PURE__*/function () {
  function J(t) {
    var _this8 = this;
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, J);
    e(this, "errors", []), e(this, "raw", new Map()), e(this, "handleError", function (e) {
      if (!_this8.options.silentErrors) throw e;
      _this8.errors.push(e.message);
    }), this.chunk = this.normalizeInput(t), this.file = i, this.type = this.constructor.type, this.globalOptions = this.options = s, this.localOptions = s[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
  }
  return _createClass(J, [{
    key: "normalizeInput",
    value: function normalizeInput(e) {
      return e instanceof c ? e : new c(e);
    }
  }, {
    key: "translate",
    value: function translate() {
      this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
    }
  }, {
    key: "output",
    get: function get() {
      return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
    }
  }, {
    key: "translateBlock",
    value: function translateBlock(e, t) {
      var s = I.get(t),
        i = V.get(t),
        n = B.get(t),
        r = this.options[t],
        a = r.reviveValues && !!s,
        h = r.translateValues && !!i,
        f = r.translateKeys && !!n,
        l = {};
      var _iterator22 = _createForOfIteratorHelper(e),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _ref10 = _step22.value;
          var _ref11 = _slicedToArray(_ref10, 2);
          var _t7 = _ref11[0];
          var _r2 = _ref11[1];
          a && s.has(_t7) ? _r2 = s.get(_t7)(_r2) : h && i.has(_t7) && (_r2 = this.translateValue(_r2, i.get(_t7))), f && n.has(_t7) && (_t7 = n.get(_t7) || _t7), l[_t7] = _r2;
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      return l;
    }
  }, {
    key: "translateValue",
    value: function translateValue(e, t) {
      return t[e] || t.DEFAULT || e;
    }
  }, {
    key: "assignToOutput",
    value: function assignToOutput(e, t) {
      this.assignObjectToOutput(e, this.constructor.type, t);
    }
  }, {
    key: "assignObjectToOutput",
    value: function assignObjectToOutput(e, t, s) {
      if (this.globalOptions.mergeOutput) return Object.assign(e, s);
      e[t] ? Object.assign(e[t], s) : e[t] = s;
    }
  }], [{
    key: "findPosition",
    value: function findPosition(e, t) {
      var s = e.getUint16(t + 2) + 2,
        i = "function" == typeof this.headerLength ? this.headerLength(e, t, s) : this.headerLength,
        n = t + i,
        r = s - i;
      return {
        offset: t,
        length: s,
        headerLength: i,
        start: n,
        size: r,
        end: n + r
      };
    }
  }, {
    key: "parse",
    value: function parse(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new this(e, new R(_defineProperty({}, this.type, t)), e).parse();
    }
  }]);
}();
e(J, "headerLength", 4), e(J, "type", void 0), e(J, "multiSegment", !1), e(J, "canHandle", function () {
  return !1;
});
function q(e) {
  return 192 === e || 194 === e || 196 === e || 219 === e || 221 === e || 218 === e || 254 === e;
}
function Q(e) {
  return e >= 224 && e <= 239;
}
function Z(e, t, s) {
  var _iterator23 = _createForOfIteratorHelper(y),
    _step23;
  try {
    for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
      var _ref12 = _step23.value;
      var _ref13 = _slicedToArray(_ref12, 2);
      var i = _ref13[0];
      var _n2 = _ref13[1];
      if (_n2.canHandle(e, t, s)) return i;
    }
  } catch (err) {
    _iterator23.e(err);
  } finally {
    _iterator23.f();
  }
}
var ee = /*#__PURE__*/function (_ref14) {
  function ee() {
    var _this9;
    _classCallCheck(this, ee);
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }
    _this9 = _callSuper(this, ee, [].concat(t)), e(_assertThisInitialized(_this9), "appSegments", []), e(_assertThisInitialized(_this9), "jpegSegments", []), e(_assertThisInitialized(_this9), "unknownSegments", []);
    return _this9;
  }
  _inherits(ee, _ref14);
  return _createClass(ee, [{
    key: "parse",
    value: function () {
      var _parse2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.findAppSegments();
            case 1:
              _context6.n = 2;
              return this.readSegments(this.appSegments);
            case 2:
              this.mergeMultiSegments();
              this.createParsers(this.mergedAppSegments || this.appSegments);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function parse() {
        return _parse2.apply(this, arguments);
      }
      return parse;
    }()
  }, {
    key: "setupSegmentFinderArgs",
    value: function setupSegmentFinderArgs(e) {
      var _this0 = this;
      !0 === e ? (this.findAll = !0, this.wanted = new Set(y.keyList())) : (e = void 0 === e ? y.keyList().filter(function (e) {
        return _this0.options[e].enabled;
      }) : e.filter(function (e) {
        return _this0.options[e].enabled && y.has(e);
      }), this.findAll = !1, this.remaining = new Set(e), this.wanted = new Set(e)), this.unfinishedMultiSegment = !1;
    }
  }, {
    key: "findAppSegments",
    value: function () {
      var _findAppSegments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this1 = this;
        var e,
          t,
          s,
          i,
          n,
          r,
          _t8,
          _i15,
          _n3,
          _args7 = arguments,
          _t9,
          _t0,
          _t1;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              e = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : 0;
              t = _args7.length > 1 ? _args7[1] : undefined;
              this.setupSegmentFinderArgs(t);
              s = this.file, i = this.findAll, n = this.wanted, r = this.remaining;
              _t9 = !i && this.file.chunked;
              if (!_t9) {
                _context7.n = 1;
                break;
              }
              i = Array.from(n).some(function (e) {
                var t = y.get(e),
                  s = _this1.options[e];
                return t.multiSegment && s.multiSegment;
              });
              _t0 = i;
              if (!_t0) {
                _context7.n = 1;
                break;
              }
              _context7.n = 1;
              return this.file.readWhole();
            case 1:
              e = this.findAppSegmentsInRange(e, s.byteLength);
              if (!(!this.options.onlyTiff && s.chunked)) {
                _context7.n = 8;
                break;
              }
              _t8 = !1;
            case 2:
              if (!(r.size > 0 && !_t8 && (s.canReadNextChunk || this.unfinishedMultiSegment))) {
                _context7.n = 8;
                break;
              }
              _i15 = s.nextChunkOffset, _n3 = this.appSegments.some(function (e) {
                return !_this1.file.available(e.offset || e.start, e.length || e.size);
              });
              if (!(e > _i15 && !_n3)) {
                _context7.n = 4;
                break;
              }
              _context7.n = 3;
              return s.readNextChunk(e);
            case 3:
              _t1 = !_context7.v;
              _context7.n = 6;
              break;
            case 4:
              _context7.n = 5;
              return s.readNextChunk(_i15);
            case 5:
              _t1 = !_context7.v;
            case 6:
              _t8 = _t1;
              if (!(void 0 === (e = this.findAppSegmentsInRange(e, s.byteLength)))) {
                _context7.n = 7;
                break;
              }
              return _context7.a(2);
            case 7:
              _context7.n = 2;
              break;
            case 8:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function findAppSegments() {
        return _findAppSegments.apply(this, arguments);
      }
      return findAppSegments;
    }()
  }, {
    key: "findAppSegmentsInRange",
    value: function findAppSegmentsInRange(e, t) {
      t -= 2;
      var s,
        i,
        n,
        r,
        a,
        h,
        f = this.file,
        l = this.findAll,
        o = this.wanted,
        u = this.remaining,
        d = this.options;
      for (; e < t; e++) if (255 === f.getUint8(e)) if (s = f.getUint8(e + 1), Q(s)) {
        if (i = f.getUint16(e + 2), n = Z(f, e, i), n && o.has(n) && (r = y.get(n), a = r.findPosition(f, e), h = d[n], a.type = n, this.appSegments.push(a), !l && (r.multiSegment && h.multiSegment ? (this.unfinishedMultiSegment = a.chunkNumber < a.chunkCount, this.unfinishedMultiSegment || u.delete(n)) : u.delete(n), 0 === u.size))) break;
        d.recordUnknownSegments && (a = J.findPosition(f, e), a.marker = s, this.unknownSegments.push(a)), e += i + 1;
      } else if (q(s)) {
        if (i = f.getUint16(e + 2), 218 === s && !1 !== d.stopAfterSos) return;
        d.recordJpegSegments && this.jpegSegments.push({
          offset: e,
          length: i,
          marker: s
        }), e += i + 1;
      }
      return e;
    }
  }, {
    key: "mergeMultiSegments",
    value: function mergeMultiSegments() {
      var _this10 = this;
      if (!this.appSegments.some(function (e) {
        return e.multiSegment;
      })) return;
      var e = function (e, t) {
        var s,
          i,
          n,
          r = new Map();
        for (var _a = 0; _a < e.length; _a++) s = e[_a], i = s[t], r.has(i) ? n = r.get(i) : r.set(i, n = []), n.push(s);
        return Array.from(r);
      }(this.appSegments, "type");
      this.mergedAppSegments = e.map(function (_ref15) {
        var _ref16 = _slicedToArray(_ref15, 2),
          e = _ref16[0],
          t = _ref16[1];
        var s = y.get(e, _this10.options);
        if (s.handleMultiSegments) {
          return {
            type: e,
            chunk: s.handleMultiSegments(t)
          };
        }
        return t[0];
      });
    }
  }, {
    key: "getSegment",
    value: function getSegment(e) {
      return this.appSegments.find(function (t) {
        return t.type === e;
      });
    }
  }, {
    key: "getOrFindSegment",
    value: function () {
      var _getOrFindSegment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
        var t, _t10;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              t = this.getSegment(e);
              _t10 = void 0 === t;
              if (!_t10) {
                _context8.n = 2;
                break;
              }
              _context8.n = 1;
              return this.findAppSegments(0, [e]);
            case 1:
              t = this.getSegment(e);
            case 2:
              return _context8.a(2, t);
          }
        }, _callee8, this);
      }));
      function getOrFindSegment(_x10) {
        return _getOrFindSegment.apply(this, arguments);
      }
      return getOrFindSegment;
    }()
  }], [{
    key: "canHandle",
    value: function canHandle(e, t) {
      return 65496 === t;
    }
  }]);
}(/*#__PURE__*/function () {
  function _class(t, s, i) {
    var _this11 = this;
    _classCallCheck(this, _class);
    e(this, "errors", []), e(this, "ensureSegmentChunk", /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(e) {
        var t, s, _t11;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              t = e.start, s = e.size || 65536;
              if (!_this11.file.chunked) {
                _context9.n = 5;
                break;
              }
              if (!_this11.file.available(t, s)) {
                _context9.n = 1;
                break;
              }
              e.chunk = _this11.file.subarray(t, s);
              _context9.n = 4;
              break;
            case 1:
              _context9.p = 1;
              _context9.n = 2;
              return _this11.file.readChunk(t, s);
            case 2:
              e.chunk = _context9.v;
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t11 = _context9.v;
              l("Couldn't read segment: ".concat(JSON.stringify(e), ". ").concat(_t11.message));
            case 4:
              _context9.n = 6;
              break;
            case 5:
              _this11.file.byteLength > t + s ? e.chunk = _this11.file.subarray(t, s) : void 0 === e.size ? e.chunk = _this11.file.subarray(t) : l("Segment unreachable: " + JSON.stringify(e));
            case 6:
              return _context9.a(2, e.chunk);
          }
        }, _callee9, null, [[1, 3]]);
      }));
      return function (_x11) {
        return _ref17.apply(this, arguments);
      };
    }()), this.extendOptions && this.extendOptions(t), this.options = t, this.file = s, this.parsers = i;
  }
  return _createClass(_class, [{
    key: "injectSegment",
    value: function injectSegment(e, t) {
      this.options[e].enabled && this.createParser(e, t);
    }
  }, {
    key: "createParser",
    value: function createParser(e, t) {
      var s = new (y.get(e))(t, this.options, this.file);
      return this.parsers[e] = s;
    }
  }, {
    key: "createParsers",
    value: function createParsers(e) {
      var _iterator24 = _createForOfIteratorHelper(e),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var _t12 = _step24.value;
          var _e9 = _t12.type,
            s = _t12.chunk,
            i = this.options[_e9];
          if (i && i.enabled) {
            var _t13 = this.parsers[_e9];
            _t13 && _t13.append || _t13 || this.createParser(_e9, s);
          }
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
    }
  }, {
    key: "readSegments",
    value: function () {
      var _readSegments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(e) {
        var t;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              t = e.map(this.ensureSegmentChunk);
              _context0.n = 1;
              return Promise.all(t);
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function readSegments(_x12) {
        return _readSegments.apply(this, arguments);
      }
      return readSegments;
    }()
  }]);
}());
e(ee, "type", "jpeg"), m.set("jpeg", ee);
var te = [void 0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8, 4];
var se = /*#__PURE__*/function (_J) {
  function se() {
    _classCallCheck(this, se);
    return _callSuper(this, se, arguments);
  }
  _inherits(se, _J);
  return _createClass(se, [{
    key: "parseHeader",
    value: function parseHeader() {
      var e = this.chunk.getUint16();
      18761 === e ? this.le = !0 : 19789 === e && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
    }
  }, {
    key: "parseTags",
    value: function parseTags(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Map();
      var _this$options$t = this.options[t],
        i = _this$options$t.pick,
        n = _this$options$t.skip;
      i = new Set(i);
      var r = i.size > 0,
        a = 0 === n.size,
        h = this.chunk.getUint16(e);
      e += 2;
      for (var _f = 0; _f < h; _f++) {
        var _h = this.chunk.getUint16(e);
        if (r) {
          if (i.has(_h) && (s.set(_h, this.parseTag(e, _h, t)), i.delete(_h), 0 === i.size)) break;
        } else !a && n.has(_h) || s.set(_h, this.parseTag(e, _h, t));
        e += 12;
      }
      return s;
    }
  }, {
    key: "parseTag",
    value: function parseTag(e, t, s) {
      var i = this.chunk,
        n = i.getUint16(e + 2),
        r = i.getUint32(e + 4),
        a = te[n];
      if (a * r <= 4 ? e += 8 : e = i.getUint32(e + 8), (n < 1 || n > 13) && l("Invalid TIFF value type. block: ".concat(s.toUpperCase(), ", tag: ").concat(t.toString(16), ", type: ").concat(n, ", offset ").concat(e)), e > i.byteLength && l("Invalid TIFF value offset. block: ".concat(s.toUpperCase(), ", tag: ").concat(t.toString(16), ", type: ").concat(n, ", offset ").concat(e, " is outside of chunk size ").concat(i.byteLength)), 1 === n) return i.getUint8Array(e, r);
      if (2 === n) return "" === (h = function (e) {
        for (; e.endsWith("\0");) e = e.slice(0, -1);
        return e;
      }(h = i.getString(e, r)).trim()) ? void 0 : h;
      var h;
      if (7 === n) return i.getUint8Array(e, r);
      if (1 === r) return this.parseTagValue(n, e);
      {
        var _t14 = new (function (e) {
            switch (e) {
              case 1:
                return Uint8Array;
              case 3:
                return Uint16Array;
              case 4:
                return Uint32Array;
              case 5:
                return Array;
              case 6:
                return Int8Array;
              case 8:
                return Int16Array;
              case 9:
                return Int32Array;
              case 10:
                return Array;
              case 11:
                return Float32Array;
              case 12:
                return Float64Array;
              default:
                return Array;
            }
          }(n))(r),
          _s0 = a;
        for (var _i16 = 0; _i16 < r; _i16++) _t14[_i16] = this.parseTagValue(n, e), e += _s0;
        return _t14;
      }
    }
  }, {
    key: "parseTagValue",
    value: function parseTagValue(e, t) {
      var s = this.chunk;
      switch (e) {
        case 1:
          return s.getUint8(t);
        case 3:
          return s.getUint16(t);
        case 4:
          return s.getUint32(t);
        case 5:
          return s.getUint32(t) / s.getUint32(t + 4);
        case 6:
          return s.getInt8(t);
        case 8:
          return s.getInt16(t);
        case 9:
          return s.getInt32(t);
        case 10:
          return s.getInt32(t) / s.getInt32(t + 4);
        case 11:
          return s.getFloat(t);
        case 12:
          return s.getDouble(t);
        case 13:
          return s.getUint32(t);
        default:
          l("Invalid tiff type ".concat(e));
      }
    }
  }]);
}(J);
var ie = /*#__PURE__*/function (_se) {
  function ie() {
    _classCallCheck(this, ie);
    return _callSuper(this, ie, arguments);
  }
  _inherits(ie, _se);
  return _createClass(ie, [{
    key: "parse",
    value: function () {
      var _parse3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var e, _t15, _t16, _t17, _t18, _t19;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this.parseHeader();
              e = this.options;
              _t15 = e.ifd0.enabled;
              if (!_t15) {
                _context1.n = 1;
                break;
              }
              _context1.n = 1;
              return this.parseIfd0Block();
            case 1:
              _t16 = e.exif.enabled;
              if (!_t16) {
                _context1.n = 2;
                break;
              }
              _context1.n = 2;
              return this.safeParse("parseExifBlock");
            case 2:
              _t17 = e.gps.enabled;
              if (!_t17) {
                _context1.n = 3;
                break;
              }
              _context1.n = 3;
              return this.safeParse("parseGpsBlock");
            case 3:
              _t18 = e.interop.enabled;
              if (!_t18) {
                _context1.n = 4;
                break;
              }
              _context1.n = 4;
              return this.safeParse("parseInteropBlock");
            case 4:
              _t19 = e.ifd1.enabled;
              if (!_t19) {
                _context1.n = 5;
                break;
              }
              _context1.n = 5;
              return this.safeParse("parseThumbnailBlock");
            case 5:
              return _context1.a(2, this.createOutput());
          }
        }, _callee1, this);
      }));
      function parse() {
        return _parse3.apply(this, arguments);
      }
      return parse;
    }()
  }, {
    key: "safeParse",
    value: function safeParse(e) {
      var t = this[e]();
      return void 0 !== t.catch && (t = t.catch(this.handleError)), t;
    }
  }, {
    key: "findIfd0Offset",
    value: function findIfd0Offset() {
      void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
    }
  }, {
    key: "findIfd1Offset",
    value: function findIfd1Offset() {
      if (void 0 === this.ifd1Offset) {
        this.findIfd0Offset();
        var _e0 = this.chunk.getUint16(this.ifd0Offset),
          _t20 = this.ifd0Offset + 2 + 12 * _e0;
        this.ifd1Offset = this.chunk.getUint32(_t20);
      }
    }
  }, {
    key: "parseBlock",
    value: function parseBlock(e, t) {
      var s = new Map();
      return this[t] = s, this.parseTags(e, t, s), s;
    }
  }, {
    key: "parseIfd0Block",
    value: function () {
      var _parseIfd0Block = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var e, t, _t21;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (!this.ifd0) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              e = this.file;
              this.findIfd0Offset();
              this.ifd0Offset < 8 && l("Malformed EXIF data");
              !e.chunked && this.ifd0Offset > e.byteLength && l("IFD0 offset points to outside of file.\nthis.ifd0Offset: ".concat(this.ifd0Offset, ", file.byteLength: ").concat(e.byteLength));
              _t21 = e.tiff;
              if (!_t21) {
                _context10.n = 2;
                break;
              }
              _context10.n = 2;
              return e.ensureChunk(this.ifd0Offset, o(this.options));
            case 2:
              t = this.parseBlock(this.ifd0Offset, "ifd0");
              return _context10.a(2, 0 !== t.size ? (this.exifOffset = t.get(34665), this.interopOffset = t.get(40965), this.gpsOffset = t.get(34853), this.xmp = t.get(700), this.iptc = t.get(33723), this.icc = t.get(34675), this.options.sanitize && (t.delete(34665), t.delete(40965), t.delete(34853), t.delete(700), t.delete(33723), t.delete(34675)), t) : void 0);
          }
        }, _callee10, this);
      }));
      function parseIfd0Block() {
        return _parseIfd0Block.apply(this, arguments);
      }
      return parseIfd0Block;
    }()
  }, {
    key: "parseExifBlock",
    value: function () {
      var _parseExifBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var e, _t22, _t23;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (!this.exif) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              _t22 = this.ifd0;
              if (_t22) {
                _context11.n = 2;
                break;
              }
              _context11.n = 2;
              return this.parseIfd0Block();
            case 2:
              if (!(void 0 === this.exifOffset)) {
                _context11.n = 3;
                break;
              }
              return _context11.a(2);
            case 3:
              _t23 = this.file.tiff;
              if (!_t23) {
                _context11.n = 4;
                break;
              }
              _context11.n = 4;
              return this.file.ensureChunk(this.exifOffset, o(this.options));
            case 4:
              e = this.parseBlock(this.exifOffset, "exif");
              return _context11.a(2, (this.interopOffset || (this.interopOffset = e.get(40965)), this.makerNote = e.get(37500), this.userComment = e.get(37510), this.options.sanitize && (e.delete(40965), e.delete(37500), e.delete(37510)), this.unpack(e, 41728), this.unpack(e, 41729), e));
          }
        }, _callee11, this);
      }));
      function parseExifBlock() {
        return _parseExifBlock.apply(this, arguments);
      }
      return parseExifBlock;
    }()
  }, {
    key: "unpack",
    value: function unpack(e, t) {
      var s = e.get(t);
      s && 1 === s.length && e.set(t, s[0]);
    }
  }, {
    key: "parseGpsBlock",
    value: function () {
      var _parseGpsBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var e, _t24;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              if (!this.gps) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              _t24 = this.ifd0;
              if (_t24) {
                _context12.n = 2;
                break;
              }
              _context12.n = 2;
              return this.parseIfd0Block();
            case 2:
              if (!(void 0 === this.gpsOffset)) {
                _context12.n = 3;
                break;
              }
              return _context12.a(2);
            case 3:
              e = this.parseBlock(this.gpsOffset, "gps");
              return _context12.a(2, (e && e.has(2) && e.has(4) && (e.set("latitude", ne.apply(void 0, _toConsumableArray(e.get(2)).concat([e.get(1)]))), e.set("longitude", ne.apply(void 0, _toConsumableArray(e.get(4)).concat([e.get(3)])))), e));
          }
        }, _callee12, this);
      }));
      function parseGpsBlock() {
        return _parseGpsBlock.apply(this, arguments);
      }
      return parseGpsBlock;
    }()
  }, {
    key: "parseInteropBlock",
    value: function () {
      var _parseInteropBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var _t25, _t26, _t27;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _t25 = !this.interop;
              if (!_t25) {
                _context13.n = 3;
                break;
              }
              _t26 = this.ifd0;
              if (_t26) {
                _context13.n = 1;
                break;
              }
              _context13.n = 1;
              return this.parseIfd0Block();
            case 1:
              _t27 = void 0 !== this.interopOffset || this.exif;
              if (_t27) {
                _context13.n = 2;
                break;
              }
              _context13.n = 2;
              return this.parseExifBlock();
            case 2:
              _t25 = void 0 !== this.interopOffset;
            case 3:
              if (!_t25) {
                _context13.n = 4;
                break;
              }
              return _context13.a(2, this.parseBlock(this.interopOffset, "interop"));
            case 4:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function parseInteropBlock() {
        return _parseInteropBlock.apply(this, arguments);
      }
      return parseInteropBlock;
    }()
  }, {
    key: "parseThumbnailBlock",
    value: function () {
      var _parseThumbnailBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var e,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              e = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : !1;
              if (!(!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e))) {
                _context14.n = 1;
                break;
              }
              return _context14.a(2, (this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1));
            case 1:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function parseThumbnailBlock() {
        return _parseThumbnailBlock.apply(this, arguments);
      }
      return parseThumbnailBlock;
    }()
  }, {
    key: "extractThumbnail",
    value: function () {
      var _extractThumbnail2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var e, t, _t28;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              this.headerParsed || this.parseHeader();
              _t28 = this.ifd1Parsed;
              if (_t28) {
                _context15.n = 1;
                break;
              }
              _context15.n = 1;
              return this.parseThumbnailBlock(!0);
            case 1:
              if (!(void 0 === this.ifd1)) {
                _context15.n = 2;
                break;
              }
              return _context15.a(2);
            case 2:
              e = this.ifd1.get(513), t = this.ifd1.get(514);
              return _context15.a(2, this.chunk.getUint8Array(e, t));
          }
        }, _callee15, this);
      }));
      function extractThumbnail() {
        return _extractThumbnail2.apply(this, arguments);
      }
      return extractThumbnail;
    }()
  }, {
    key: "image",
    get: function get() {
      return this.ifd0;
    }
  }, {
    key: "thumbnail",
    get: function get() {
      return this.ifd1;
    }
  }, {
    key: "createOutput",
    value: function createOutput() {
      var e,
        t,
        s,
        i = {};
      for (var _i17 = 0, _P3 = P; _i17 < _P3.length; _i17++) {
        t = _P3[_i17];
        if (e = this[t], !f(e)) if (s = this.canTranslate ? this.translateBlock(e, t) : Object.fromEntries(e), this.options.mergeOutput) {
          if ("ifd1" === t) continue;
          Object.assign(i, s);
        } else i[t] = s;
      }
      return this.makerNote && (i.makerNote = this.makerNote), this.userComment && (i.userComment = this.userComment), i;
    }
  }, {
    key: "assignToOutput",
    value: function assignToOutput(e, t) {
      if (this.globalOptions.mergeOutput) Object.assign(e, t);else for (var _i18 = 0, _Object$entries = Object.entries(t); _i18 < _Object$entries.length; _i18++) {
        var _ref18 = _Object$entries[_i18];
        var _ref19 = _slicedToArray(_ref18, 2);
        var s = _ref19[0];
        var i = _ref19[1];
        this.assignObjectToOutput(e, s, i);
      }
    }
  }], [{
    key: "canHandle",
    value: function canHandle(e, t) {
      return 225 === e.getUint8(t + 1) && 1165519206 === e.getUint32(t + 4) && 0 === e.getUint16(t + 8);
    }
  }]);
}(se);
function ne(e, t, s, i) {
  var n = e + t / 60 + s / 3600;
  return "S" !== i && "W" !== i || (n *= -1), n;
}
e(ie, "type", "tiff"), e(ie, "headerLength", 10), y.set("tiff", ie);
var re = Object.freeze({
  __proto__: null,
  default: G,
  Exifr: H,
  fileParsers: m,
  segmentParsers: y,
  fileReaders: b,
  tagKeys: B,
  tagValues: V,
  tagRevivers: I,
  createDictionary: x,
  extendDictionary: C,
  fetchUrlAsArrayBuffer: S,
  readBlobAsArrayBuffer: A,
  chunkedProps: L,
  otherSegments: T,
  segments: z,
  tiffBlocks: P,
  segmentsAndBlocks: F,
  tiffExtractables: j,
  inheritables: E,
  allFormatters: M,
  Options: R,
  parse: Y
});
var ae = {
    ifd0: !1,
    ifd1: !1,
    exif: !1,
    gps: !1,
    interop: !1,
    sanitize: !1,
    reviveValues: !0,
    translateKeys: !1,
    translateValues: !1,
    mergeOutput: !1
  },
  he = exports.gpsOnlyOptions = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    gps: [1, 2, 3, 4]
  });
function fe(_x13) {
  return _fe.apply(this, arguments);
}
function _fe() {
  _fe = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(e) {
    var t, s, _s$gps, _e13, _t36;
    return _regenerator().w(function (_context27) {
      while (1) switch (_context27.n) {
        case 0:
          t = new H(he);
          _context27.n = 1;
          return t.read(e);
        case 1:
          _context27.n = 2;
          return t.parse();
        case 2:
          s = _context27.v;
          if (!(s && s.gps)) {
            _context27.n = 3;
            break;
          }
          _s$gps = s.gps, _e13 = _s$gps.latitude, _t36 = _s$gps.longitude;
          return _context27.a(2, {
            latitude: _e13,
            longitude: _t36
          });
        case 3:
          return _context27.a(2);
      }
    }, _callee27);
  }));
  return _fe.apply(this, arguments);
}
var le = exports.thumbnailOnlyOptions = Object.assign({}, ae, {
  tiff: !1,
  ifd1: !0,
  mergeOutput: !1
});
function oe(_x14) {
  return _oe.apply(this, arguments);
}
function _oe() {
  _oe = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(e) {
    var t, s;
    return _regenerator().w(function (_context28) {
      while (1) switch (_context28.n) {
        case 0:
          t = new H(le);
          _context28.n = 1;
          return t.read(e);
        case 1:
          _context28.n = 2;
          return t.extractThumbnail();
        case 2:
          s = _context28.v;
          return _context28.a(2, s && a ? r.from(s) : s);
      }
    }, _callee28);
  }));
  return _oe.apply(this, arguments);
}
function ue(_x15) {
  return _ue.apply(this, arguments);
}
function _ue() {
  _ue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(e) {
    var t, _e14;
    return _regenerator().w(function (_context29) {
      while (1) switch (_context29.n) {
        case 0:
          _context29.n = 1;
          return this.thumbnail(e);
        case 1:
          t = _context29.v;
          if (!(void 0 !== t)) {
            _context29.n = 2;
            break;
          }
          _e14 = new Blob([t]);
          return _context29.a(2, URL.createObjectURL(_e14));
        case 2:
          return _context29.a(2);
      }
    }, _callee29, this);
  }));
  return _ue.apply(this, arguments);
}
var de = exports.orientationOnlyOptions = Object.assign({}, ae, {
  firstChunkSize: 4e4,
  ifd0: [274]
});
function ce(_x16) {
  return _ce.apply(this, arguments);
}
function _ce() {
  _ce = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(e) {
    var t, s;
    return _regenerator().w(function (_context30) {
      while (1) switch (_context30.n) {
        case 0:
          t = new H(de);
          _context30.n = 1;
          return t.read(e);
        case 1:
          _context30.n = 2;
          return t.parse();
        case 2:
          s = _context30.v;
          if (!(s && s.ifd0)) {
            _context30.n = 3;
            break;
          }
          return _context30.a(2, s.ifd0[274]);
        case 3:
          return _context30.a(2);
      }
    }, _callee30);
  }));
  return _ce.apply(this, arguments);
}
var pe = exports.rotations = Object.freeze({
  1: {
    dimensionSwapped: !1,
    scaleX: 1,
    scaleY: 1,
    deg: 0,
    rad: 0
  },
  2: {
    dimensionSwapped: !1,
    scaleX: -1,
    scaleY: 1,
    deg: 0,
    rad: 0
  },
  3: {
    dimensionSwapped: !1,
    scaleX: 1,
    scaleY: 1,
    deg: 180,
    rad: 180 * Math.PI / 180
  },
  4: {
    dimensionSwapped: !1,
    scaleX: -1,
    scaleY: 1,
    deg: 180,
    rad: 180 * Math.PI / 180
  },
  5: {
    dimensionSwapped: !0,
    scaleX: 1,
    scaleY: -1,
    deg: 90,
    rad: 90 * Math.PI / 180
  },
  6: {
    dimensionSwapped: !0,
    scaleX: 1,
    scaleY: 1,
    deg: 90,
    rad: 90 * Math.PI / 180
  },
  7: {
    dimensionSwapped: !0,
    scaleX: 1,
    scaleY: -1,
    deg: 270,
    rad: 270 * Math.PI / 180
  },
  8: {
    dimensionSwapped: !0,
    scaleX: 1,
    scaleY: 1,
    deg: 270,
    rad: 270 * Math.PI / 180
  }
});
var ge = exports.rotateCanvas = !0,
  me = exports.rotateCss = !0;
if ("object" == (typeof navigator === "undefined" ? "undefined" : _typeof(navigator))) {
  var _e1 = navigator.userAgent;
  if (_e1.includes("iPad") || _e1.includes("iPhone")) {
    var _t29 = _e1.match(/OS (\d+)_(\d+)/);
    if (_t29) {
      var _t30 = _slicedToArray(_t29, 3),
        _e10 = _t30[1],
        s = _t30[2],
        i = Number(_e10) + .1 * Number(s);
      exports.rotateCanvas = ge = i < 13.4, exports.rotateCss = me = !1;
    }
  } else if (_e1.includes("OS X 10")) {
    var _e1$match = _e1.match(/OS X 10[_.](\d+)/),
      _e1$match2 = _slicedToArray(_e1$match, 2),
      _t31 = _e1$match2[1];
    exports.rotateCanvas = ge = exports.rotateCss = me = Number(_t31) < 15;
  }
  if (_e1.includes("Chrome/")) {
    var _e1$match3 = _e1.match(/Chrome\/(\d+)/),
      _e1$match4 = _slicedToArray(_e1$match3, 2),
      _t32 = _e1$match4[1];
    exports.rotateCanvas = ge = exports.rotateCss = me = Number(_t32) < 81;
  } else if (_e1.includes("Firefox/")) {
    var _e1$match5 = _e1.match(/Firefox\/(\d+)/),
      _e1$match6 = _slicedToArray(_e1$match5, 2),
      _t33 = _e1$match6[1];
    exports.rotateCanvas = ge = exports.rotateCss = me = Number(_t33) < 77;
  }
}
function ye(_x17) {
  return _ye.apply(this, arguments);
}
function _ye() {
  _ye = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(e) {
    var t;
    return _regenerator().w(function (_context31) {
      while (1) switch (_context31.n) {
        case 0:
          _context31.n = 1;
          return ce(e);
        case 1:
          t = _context31.v;
          return _context31.a(2, Object.assign({
            canvas: ge,
            css: me
          }, pe[t]));
      }
    }, _callee31);
  }));
  return _ye.apply(this, arguments);
}
var be = /*#__PURE__*/function (_c) {
  function be() {
    var _this12;
    _classCallCheck(this, be);
    for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      t[_key2] = arguments[_key2];
    }
    _this12 = _callSuper(this, be, [].concat(t)), e(_assertThisInitialized(_this12), "ranges", new we()), 0 !== _this12.byteLength && _this12.ranges.add(0, _this12.byteLength);
    return _this12;
  }
  _inherits(be, _c);
  return _createClass(be, [{
    key: "_tryExtend",
    value: function _tryExtend(e, t, s) {
      if (0 === e && 0 === this.byteLength && s) {
        var _e11 = new DataView(s.buffer || s, s.byteOffset, s.byteLength);
        this._swapDataView(_e11);
      } else {
        var _s1 = e + t;
        if (_s1 > this.byteLength) {
          var _this$_extend = this._extend(_s1),
            _e12 = _this$_extend.dataView;
          this._swapDataView(_e12);
        }
      }
    }
  }, {
    key: "_extend",
    value: function _extend(e) {
      var t;
      t = a ? r.allocUnsafe(e) : new Uint8Array(e);
      var s = new DataView(t.buffer, t.byteOffset, t.byteLength);
      return t.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), {
        uintView: t,
        dataView: s
      };
    }
  }, {
    key: "subarray",
    value: function subarray(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return t = t || this._lengthToEnd(e), s && this._tryExtend(e, t), this.ranges.add(e, t), _superPropGet(be, "subarray", this, 3)([e, t]);
    }
  }, {
    key: "set",
    value: function set(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      s && this._tryExtend(t, e.byteLength, e);
      var i = _superPropGet(be, "set", this, 3)([e, t]);
      return this.ranges.add(t, i.byteLength), i;
    }
  }, {
    key: "ensureChunk",
    value: function () {
      var _ensureChunk = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(e, t) {
        var _t34, _t35;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              _t34 = this.chunked;
              if (!_t34) {
                _context16.n = 1;
                break;
              }
              _t35 = this.ranges.available(e, t);
              if (_t35) {
                _context16.n = 1;
                break;
              }
              _context16.n = 1;
              return this.readChunk(e, t);
            case 1:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function ensureChunk(_x18, _x19) {
        return _ensureChunk.apply(this, arguments);
      }
      return ensureChunk;
    }()
  }, {
    key: "available",
    value: function available(e, t) {
      return this.ranges.available(e, t);
    }
  }]);
}(c);
var we = /*#__PURE__*/function () {
  function we() {
    _classCallCheck(this, we);
    e(this, "list", []);
  }
  return _createClass(we, [{
    key: "length",
    get: function get() {
      return this.list.length;
    }
  }, {
    key: "add",
    value: function add(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = e + t,
        n = this.list.filter(function (t) {
          return ke(e, t.offset, i) || ke(e, t.end, i);
        });
      if (n.length > 0) {
        e = Math.min.apply(Math, [e].concat(_toConsumableArray(n.map(function (e) {
          return e.offset;
        })))), i = Math.max.apply(Math, [i].concat(_toConsumableArray(n.map(function (e) {
          return e.end;
        })))), t = i - e;
        var _s10 = n.shift();
        _s10.offset = e, _s10.length = t, _s10.end = i, this.list = this.list.filter(function (e) {
          return !n.includes(e);
        });
      } else this.list.push({
        offset: e,
        length: t,
        end: i
      });
    }
  }, {
    key: "available",
    value: function available(e, t) {
      var s = e + t;
      return this.list.some(function (t) {
        return t.offset <= e && s <= t.end;
      });
    }
  }]);
}();
function ke(e, t, s) {
  return e <= t && t <= s;
}
var Oe = /*#__PURE__*/function (_be) {
  function Oe(t, s) {
    var _this13;
    _classCallCheck(this, Oe);
    _this13 = _callSuper(this, Oe, [0]), e(_assertThisInitialized(_this13), "chunksRead", 0), _this13.input = t, _this13.options = s;
    return _this13;
  }
  _inherits(Oe, _be);
  return _createClass(Oe, [{
    key: "readWhole",
    value: function () {
      var _readWhole = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              this.chunked = !1;
              _context17.n = 1;
              return this.readChunk(this.nextChunkOffset);
            case 1:
              return _context17.a(2);
          }
        }, _callee17, this);
      }));
      function readWhole() {
        return _readWhole.apply(this, arguments);
      }
      return readWhole;
    }()
  }, {
    key: "readChunked",
    value: function () {
      var _readChunked = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              this.chunked = !0;
              _context18.n = 1;
              return this.readChunk(0, this.options.firstChunkSize);
            case 1:
              return _context18.a(2);
          }
        }, _callee18, this);
      }));
      function readChunked() {
        return _readChunked.apply(this, arguments);
      }
      return readChunked;
    }()
  }, {
    key: "readNextChunk",
    value: function () {
      var _readNextChunk = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        var e,
          t,
          s,
          _args19 = arguments;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              e = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : this.nextChunkOffset;
              if (!this.fullyRead) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2, (this.chunksRead++, !1));
            case 1:
              t = this.options.chunkSize;
              _context19.n = 2;
              return this.readChunk(e, t);
            case 2:
              s = _context19.v;
              return _context19.a(2, !!s && s.byteLength === t);
          }
        }, _callee19, this);
      }));
      function readNextChunk() {
        return _readNextChunk.apply(this, arguments);
      }
      return readNextChunk;
    }()
  }, {
    key: "readChunk",
    value: function () {
      var _readChunk = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(e, t) {
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              if (!(this.chunksRead++, 0 !== (t = this.safeWrapAddress(e, t)))) {
                _context20.n = 1;
                break;
              }
              return _context20.a(2, this._readChunk(e, t));
            case 1:
              return _context20.a(2);
          }
        }, _callee20, this);
      }));
      function readChunk(_x20, _x21) {
        return _readChunk.apply(this, arguments);
      }
      return readChunk;
    }()
  }, {
    key: "safeWrapAddress",
    value: function safeWrapAddress(e, t) {
      return void 0 !== this.size && e + t > this.size ? Math.max(0, this.size - e) : t;
    }
  }, {
    key: "nextChunkOffset",
    get: function get() {
      if (0 !== this.ranges.list.length) return this.ranges.list[0].length;
    }
  }, {
    key: "canReadNextChunk",
    get: function get() {
      return this.chunksRead < this.options.chunkLimit;
    }
  }, {
    key: "fullyRead",
    get: function get() {
      return void 0 !== this.size && this.nextChunkOffset === this.size;
    }
  }, {
    key: "read",
    value: function read() {
      return this.options.chunked ? this.readChunked() : this.readWhole();
    }
  }, {
    key: "close",
    value: function close() {}
  }]);
}(be);
b.set("blob", /*#__PURE__*/function (_Oe) {
  function _class2() {
    _classCallCheck(this, _class2);
    return _callSuper(this, _class2, arguments);
  }
  _inherits(_class2, _Oe);
  return _createClass(_class2, [{
    key: "readWhole",
    value: function () {
      var _readWhole2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        var e;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              this.chunked = !1;
              _context21.n = 1;
              return A(this.input);
            case 1:
              e = _context21.v;
              this._swapArrayBuffer(e);
            case 2:
              return _context21.a(2);
          }
        }, _callee21, this);
      }));
      function readWhole() {
        return _readWhole2.apply(this, arguments);
      }
      return readWhole;
    }()
  }, {
    key: "readChunked",
    value: function readChunked() {
      return this.chunked = !0, this.size = this.input.size, _superPropGet(_class2, "readChunked", this, 3)([]);
    }
  }, {
    key: "_readChunk",
    value: function () {
      var _readChunk2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(e, t) {
        var s, i, n;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              s = t ? e + t : void 0;
              i = this.input.slice(e, s);
              _context22.n = 1;
              return A(i);
            case 1:
              n = _context22.v;
              return _context22.a(2, this.set(n, e, !0));
          }
        }, _callee22, this);
      }));
      function _readChunk(_x22, _x23) {
        return _readChunk2.apply(this, arguments);
      }
      return _readChunk;
    }()
  }]);
}(Oe));
var _default = exports.default = re;